import { render, staticRenderFns } from "./GestorCentralizadoTable.vue?vue&type=template&id=041f9264&"
import script from "./GestorCentralizadoTable.vue?vue&type=script&lang=js&"
export * from "./GestorCentralizadoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports